import { useToast } from '@getaccept/lib-shared-new/src/toast';
import { useAsyncState } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { QesService } from '../../api/qes/services/qes.service';

export const useQesFileDownload = () => {
  const { t } = useI18n();
  return useAsyncState(
    ({ documentId, fileId }: { documentId: string; fileId: string }) =>
      QesService.getFileDownloadLink(documentId, fileId),
    null,
    {
      immediate: false,
      onSuccess(url) {
        window.open(url, '_blank');
      },
      onError() {
        const { toast } = useToast();
        toast.danger(t('qes_file_download_error'));
      },
    }
  );
};
